import {
  SEND_BY_EMAIL,
  SEND_TO_PLATFORM_USER
} from '../../../Multiplatform/MediaOrderForms/AmendmentContractSendForm/fields'

export const getRecipientsOptions = isMultiple => [
  { label: isMultiple ? 'Users' : 'User', value: SEND_TO_PLATFORM_USER },
  { label: isMultiple ? 'Emails' : 'Email', value: SEND_BY_EMAIL }
]
